var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0419 5H10.9581C7.67279 5 5 7.67279 5 10.9581V19.0419C5 22.3272 7.67279 25 10.9581 25H19.0419C22.3272 25 25 22.3272 25 19.0419V10.9581C25 7.67279 22.3272 5 19.0419 5ZM22.988 19.0419C22.988 21.2213 21.2213 22.988 19.0419 22.988H10.9581C8.77875 22.988 7.012 21.2213 7.012 19.0419V10.9581C7.012 8.77871 8.77875 7.012 10.9581 7.012H19.0419C21.2213 7.012 22.988 8.77871 22.988 10.9581V19.0419Z",
    fill: "url(#paint0_linear_2713_36447)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 9.82715C12.1476 9.82715 9.82715 12.1476 9.82715 14.9998C9.82715 17.852 12.1476 20.1725 14.9999 20.1725C17.8521 20.1725 20.1726 17.8521 20.1726 14.9998C20.1726 12.1476 17.8521 9.82715 14.9999 9.82715ZM14.9999 18.1606C13.2542 18.1606 11.8391 16.7455 11.8391 14.9999C11.8391 13.2542 13.2543 11.8391 14.9999 11.8391C16.7455 11.8391 18.1606 13.2542 18.1606 14.9999C18.1606 16.7455 16.7455 18.1606 14.9999 18.1606Z",
    fill: "url(#paint1_linear_2713_36447)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1828 11.1057C20.8674 11.1057 21.4223 10.5507 21.4223 9.8662C21.4223 9.18165 20.8674 8.62671 20.1828 8.62671C19.4983 8.62671 18.9434 9.18165 18.9434 9.8662C18.9434 10.5507 19.4983 11.1057 20.1828 11.1057Z",
    fill: "url(#paint2_linear_2713_36447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2713_36447",
    x1: 15,
    y1: 24.9418,
    x2: 15,
    y2: 5.15534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2713_36447",
    x1: 14.9999,
    y1: 24.9416,
    x2: 14.9999,
    y2: 5.1552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2713_36447",
    x1: 20.1828,
    y1: 24.9418,
    x2: 20.1828,
    y2: 5.15542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6726ed787b3730a631598983e4967455.svg";
export { ForwardRef as ReactComponent };